module.exports = __webpack_public_path__ + "static/media/Sharedesc.41973106.svg";